import { observer } from 'mobx-react-lite'
import { Schedule } from 'shared/ui/Schedule'
import { useBroadcastViewContext } from 'pages/broadcasts/ui/BroadcastView/context/broadcastViewContext'

export const BroadcastSchedule = observer(() => {
  const store = useBroadcastViewContext()

  return <Schedule scheduleStore={store.broadcastScheduleStore.scheduleStore} />
})
